module.exports = __webpack_public_path__ + "static/AnastasiiaIlina-5f41e31c78a9072a30317b3386fd7926.jpeg";